import { c as _c } from "react/compiler-runtime";
import { Modal } from '@7f-ui/components/modal/modal';
import type { AccommodationRate } from '@data-access/graphql/schema.types';
import type { AvailableRoom } from '@feat/feat-accommodation/availability';
import { AppAccommodationRoomRatesModalContent } from './app-accommodation-room-rates-modal-content';
type AppAccommodationRoomRatesModalProps = {
  room: AvailableRoom | null;
  isOpen: boolean;
  onSelect: (rate?: AccommodationRate) => Promise<void>;
  onClose: VoidFunction;
};
export function AppAccommodationRoomRatesModal(t0) {
  const $ = _c(7);
  const {
    isOpen,
    onSelect,
    onClose,
    room
  } = t0;
  let t1;
  if ($[0] !== onSelect || $[1] !== room) {
    t1 = t2 => {
      const {
        onClose: closeModal
      } = t2;
      if (!room) {
        return null;
      }
      return <><Modal.Header onClose={closeModal}>Option wählen</Modal.Header><AppAccommodationRoomRatesModalContent room={room} onSelect={onSelect} /></>;
    };
    $[0] = onSelect;
    $[1] = room;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isOpen || $[4] !== onClose || $[5] !== t1) {
    t2 = <Modal isOpen={isOpen} onClose={onClose} size="auto">{t1}</Modal>;
    $[3] = isOpen;
    $[4] = onClose;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}